import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import BackgroundImage from "../assets/images/contact/bg-09.jpg";
import cover1 from "../assets/images/docs/ten-foods-cover.svg";
import cover2 from "../assets/images/docs/ten-foods-cover-male.svg";
import EmailIcon from "../assets/images/icons/icon-email.png";
import Layout from "../components/layoutBlack";
import videoSource from '../assets/videos/cutting_leather.mp4';
import EBookForm from "../components/ebookform";

const TenFoods = () => {
    const location = useLocation();

    // Parse URL query parameters
    const queryParams = new URLSearchParams(location.search);
    const version = queryParams.get("v");

    // Choose image based on 'v'
    const selectedCover = version === "2" ? cover2 : cover1;
    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);
    return (
        <div>
            <Layout>
                {/* Title Section */}
                <section className="bg-img1 txt-center p-lr-15 p-tb-20">
                </section>              

                {/* Content Section */}
                <section className="full-page-section bg0 p-t-60 p-b-125">
                    <div className="container">
                        <div className="flex-w flex-tr">
                            {/* Contact Form */}
                            <div className="size-210 bor10 d-flex align-items-center p-lr-70 p-t-55 p-b-70 p-lr-15-lg w-full-md">
                                <div className="w-100">
                                    <EBookForm version={version} />
                                </div>
                            </div>

                            {/* Contact Details */}
                            <div className="size-210 bor10 flex-w flex-col-m p-lr-60 p-lr-15-lg w-full-md">
                                <div className="book-cover">
                                    <img src={selectedCover} alt="Book Cover" style={{ maxWidth: "100%" }} />
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </Layout>
        </div>
    );
};

export default TenFoods;

